class AlertNotification {
  constructor() {
    this.initNotificationContainer();
    this.notification = document.querySelector('.alert-notification');
    this.delayTime = 3500;
    this.timerId = null;
    this.isActive = false;
  }

  showMessage(message, type) {
    this.clearNotification();
    this.notification.innerHTML = message;
    this.notification.classList.add('active', type);
    this.isActive = true;

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    if (this.isActive && type === 'error') {
      this.notification.classList.add('shake');

      setTimeout(() => {
        this.notification.classList.remove('shake');
      }, 500);
    }

    this.timerId = setTimeout(() => {
      this.notification.classList.remove('active', type);

      this.isActive = false;
    }, this.delayTime);
  }

  success(message, delayTime= null) {
    if (delayTime) {
      this.delayTime = delayTime;
    }
    this.showMessage(message, 'success');
  }

  error(message, delayTime= null) {
    if (delayTime) {
      this.delayTime = delayTime;
    }
    this.showMessage(message, 'error');
  }

  warning(message, delayTime= null) {
    if (delayTime) {
      this.delayTime = delayTime;
    }
    this.showMessage(message, 'warning');
  }

  info(message, delayTime= null) {
    if (delayTime) {
      this.delayTime = delayTime;
    }
    this.showMessage(message, 'information');
  }

  clearNotification() {
    this.notification.textContent = '';
    this.notification.classList.remove('active', 'success', 'error', 'warning', 'information');
  }

  initNotificationContainer() {
    const notificationDiv = document.createElement('div');
    notificationDiv.className = 'alert-notification';
    const mainTag = document.querySelector('main') || document.body;
    mainTag.insertAdjacentElement('afterbegin', notificationDiv);
    this.notification = notificationDiv;
  }
}
document.addEventListener('DOMContentLoaded', () => {
  window.alertNotification = new AlertNotification();
});